module.exports = {"411724001":"真阳街道","411724002":"清源街道","411724101":"寒冻镇","411724102":"汝南埠镇","411724103":"铜钟镇","411724104":"陡沟镇","411724105":"熊寨镇","411724106":"大林镇","411724107":"永兴镇","411724108":"袁寨镇","411724200":"慎水乡","411724201":"傅寨乡","411724203":"新阮店乡","411724204":"油坊店乡","411724207":"雷寨乡","411724208":"王勿桥乡","411724210":"吕河乡","411724212":"皮店乡","411724213":"彭桥乡","411724214":"兰青乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411724.json
// module id = 1690
// module chunks = 0